<template>
    <div class="component component__library_grid">
        <div class="container">
            <div :class="[
                'columns',
                'is-multiline',
                'columns--custom-desktop-tablet',
                'columns--custom-desktop-margin',
                'columns--custom-widescreen-margin',
                'is-variable',
                'is-8-touch'
            ]">
                <template v-for="(item, index) in items">
                    <div
                        :key="index"
                        :class="[
                            'column',
                            'column--custom-tablet-padding',
                            'column--custom-desktop-padding',
                            'column--custom-widescreen-padding',
                            'column--custom-tablet-width',
                            'column--custom-desktop-width',
                            'column--custom-widescreen-width',
                            'is-3-desktop',
                            'is-4-tablet',
                            'is-6-mobile'
                        ]"
                    >
                        <component-library-grid-item
                            :item="item"
                            :checkbox-active="checkboxActive"
                            :class="selected.includes(item.id) ? 'component__library_grid_item--selected' : ''"
                            @emit-check="emitCheck"
                            @emit-click="emitClick"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentLibraryGridItem from '@/components/default/shared/ComponentLibraryGridItem'

export default {
  name: 'component-library-grid',
  components: { ComponentLibraryGridItem },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array
    },
    checkboxActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitCheck (data) {
      this.$emit('emit-check', data)
    },
    emitClick (data) {
      this.$emit('emit-click', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/_componentlibrarygrid.scss";
</style>
